export const PUSH_PLATFORMS = ['ANDROID', 'IOS', 'UNKNOWN'];

export const PLATFORM_LABELS = { ANDROID: 'Android', IOS: 'iOS', UNKNOWN: 'Sin plataforma' };
export const USERTYPE_LABELS = { driver: 'Conductores', customer: 'Usuarios', All: 'Conductores y usuarios' };
export const DEVICETYPE_LABELS = { All: 'Todos los dispositivos', ANDROID: 'Solo Android', IOS: 'Solo iOS' };

export const isExpoPushToken = (t) => typeof t === 'string' && /^Expo(nent)?PushToken\[[^\]]+\]$/.test(t.trim());

const platformOf = (u) => (u && (u.userPlatform === 'IOS' || u.userPlatform === 'ANDROID') ? u.userPlatform : 'UNKNOWN');

/** Misma selección que hace el servidor en send_notification, para estimar el alcance antes de enviar. */
export function pushCoverage(users, usertype = 'All', devicetype = 'All', cityId = 'All', cityName = '') {
  const result = { users: 0, devices: 0, withoutDevice: 0, unknownPlatform: 0, ANDROID: 0, IOS: 0, UNKNOWN: 0 };
  const seen = new Set();
  (users || []).forEach((u) => {
    if (!u || (u.usertype !== 'driver' && u.usertype !== 'customer')) return;
    if (usertype !== 'All' && u.usertype !== usertype) return;
    if (cityId && cityId !== 'All') {
      const uCityId = u.cityId || '';
      const uCityName = (u.cityName || '').toLowerCase().trim();
      const targetCityId = cityId;
      const targetCityName = (cityName || '').toLowerCase().trim();
      const match = uCityId === targetCityId || (targetCityName && uCityName === targetCityName);
      if (!match) return;
    }
    const platform = platformOf(u);
    if (devicetype !== 'All' && platform !== devicetype) {
      if (platform === 'UNKNOWN') result.unknownPlatform += 1;
      return;
    }
    result.users += 1;
    if (!isExpoPushToken(u.pushToken)) {
      result.withoutDevice += 1;
      return;
    }
    const token = u.pushToken.trim();
    if (seen.has(token)) return;
    seen.add(token);
    result.devices += 1;
    result[platform] += 1;
  });
  return result;
}

const num = (v) => Number(v) || 0;

export function platformReport(n, p) {
  const targeted = num(n?.audience?.[p]);
  const accepted = num(n?.tickets?.[p]?.ok);
  const rejected = num(n?.tickets?.[p]?.error);
  const delivered = num(n?.receipts?.[p]?.ok);
  const failedReceipt = num(n?.receipts?.[p]?.error);
  const expired = num(n?.receipts?.[p]?.expired);
  return {
    targeted,
    accepted,
    delivered,
    failed: rejected + failedReceipt,
    expired,
    pending: Math.max(0, accepted - delivered - failedReceipt - expired),
  };
}

export function deliveryTotals(n) {
  return PUSH_PLATFORMS.reduce(
    (acc, p) => {
      const r = platformReport(n, p);
      Object.keys(acc).forEach((k) => {
        acc[k] += r[k];
      });
      return acc;
    },
    { targeted: 0, accepted: 0, delivered: 0, failed: 0, expired: 0, pending: 0 }
  );
}

export const DELIVERY_STATUS_UI = {
  legacy: { tone: 'neutral', label: 'Sin reporte' },
  no_devices: { tone: 'warning', label: 'Sin dispositivos' },
  sending: { tone: 'violet', label: 'Enviando' },
  verifying: { tone: 'violet', label: 'Verificando entrega' },
  delivered: { tone: 'success', label: 'Entregada' },
  partial: { tone: 'warning', label: 'Entregada con fallas' },
  failed: { tone: 'danger', label: 'No entregada' },
};

export function deliveryStatus(n) {
  if (!n || !n.audience) return 'legacy';
  if (!num(n.audience.devices)) return 'no_devices';
  if (num(n.sentChunks) < num(n.totalChunks)) return 'sending';
  const totals = deliveryTotals(n);
  if (num(n.pendingReceipts) > 0 || totals.pending > 0) return 'verifying';
  const bad = totals.failed + totals.expired;
  if (!bad) return 'delivered';
  return totals.delivered ? 'partial' : 'failed';
}

export const PUSH_ERROR_HELP = {
  DeviceNotRegistered: 'La app fue desinstalada o el celular ya no acepta notificaciones. El token se quitó de la cuenta automáticamente.',
  InvalidCredentials: 'Faltan o vencieron las credenciales push en EAS: llave APNs para iOS o cuenta de servicio FCM v1 para Android. Mientras falten, no llega ninguna notificación a esa plataforma.',
  MismatchSenderId: 'El proyecto de Firebase de la app no coincide con las credenciales FCM cargadas en EAS.',
  MessageTooBig: 'El mensaje supera el tamaño máximo (4 KB).',
  MessageRateExceeded: 'Se enviaron demasiados mensajes seguidos al mismo dispositivo.',
  TOO_MANY_REQUESTS: 'Expo rechazó el envío por exceso de velocidad (límite ~600/s). El sistema ahora espacia y reintenta; vuelve a enviar esta campaña.',
  RequestFailed: 'No hubo respuesta de Expo para ese lote; vuelve a intentarlo.',
  MissingTicket: 'Expo no confirmó ese envío; vuelve a intentarlo.',
  PUSH_TOO_MANY_EXPERIENCE_IDS: 'Hay tokens de otro proyecto Expo mezclados en la base de datos.',
};

export const pushErrorHelp = (reason) =>
  PUSH_ERROR_HELP[reason] || (String(reason).startsWith('HTTP_') ? 'Expo rechazó la solicitud; revisa el estado del servicio y vuelve a intentarlo.' : 'Error reportado por Expo.');
